import { githubClient } from "api/builder";
import { RepositoryType } from "./github.types";

export const getRepositories = githubClient.createRequest<{
  response: RepositoryType[];
  queryParams: { per_page?: number };
}>()({
  endpoint: "/users/:account/repos",
  retry: 10,
  retryTime: 1000,
});
